import './setPublicPath'
import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

// runtime shared by every component chunk
import 'css-loader/dist/runtime/api.js'
import 'vue-style-loader/lib/addStylesShadow'
import 'vue-loader/lib/runtime/componentNormalizer'

import tableProducts from '~root/src/components/AppTable/index.vue?shadow'
window.customElements.define('table-products', wrap(Vue, tableProducts))